<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useCustomizerStore } from '../../stores/customizer';
const customizer = useCustomizerStore();
</script>
<template>
    <v-locale-provider>
        <v-app class="authpage" :theme="customizer.actTheme">
            <RouterView />
        </v-app>
    </v-locale-provider>
</template>
